import {
  Box,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";

import { COLUMN_OPTIONS, type ColumnCount } from "./tileStyles";

export type GridHeaderProps = {
  total: number;
  acceptedCount: number;
  failedCount: number;
  columns: ColumnCount;
  onColumnsChange: (columns: ColumnCount) => void;
  onSaveCollection: () => void;
  saveDisabled: boolean;
};

export function GridHeader({
  total,
  acceptedCount,
  failedCount,
  columns,
  onColumnsChange,
  onSaveCollection,
  saveDisabled,
}: GridHeaderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 3,
      }}
    >
      <Box>
        <Typography variant="h5" fontWeight={700}>
          Contact sheet
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          data-testid="generated-thumbnail-grid-accepted-count"
        >
          {acceptedCount} of {total} accepted
        </Typography>
        {failedCount > 0 && (
          <Typography
            variant="body2"
            color="error.main"
            data-testid="generated-thumbnail-grid-failed-count"
          >
            {failedCount} failed to generate
          </Typography>
        )}
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
        <ToggleButtonGroup
          size="small"
          exclusive
          value={columns}
          onChange={(_event, value: ColumnCount | null) => {
            if (value !== null) onColumnsChange(value);
          }}
          aria-label="Grid columns"
        >
          {COLUMN_OPTIONS.map((option) => (
            <ToggleButton
              key={option}
              value={option}
              aria-label={`${option} columns`}
            >
              {option}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>

        <Button
          variant="contained"
          onClick={onSaveCollection}
          disabled={saveDisabled || acceptedCount === 0}
        >
          Save collection
        </Button>
      </Box>
    </Box>
  );
}
